import { Text } from '@chakra-ui/react';
import { SearchResults } from 'pages/in-app/SearchResults';
import { ReactElement } from 'react';
import { useModalNavigation } from '../ModalNavigationContext';
import { Category } from './Category';
import { Folder } from './Folder';
import { Article } from './Article';
import { Categories } from './Categories';
import { Medication } from './Medication';

export const ArticleModalRouter = (): ReactElement | null => {
  const modalNav = useModalNavigation();

  switch (modalNav?.screen.name) {
    case 'categories':
      return <Categories />;
    case 'category':
      return <Category id={modalNav.screen.params.id} />;
    case 'folder':
      return <Folder id={modalNav.screen.params.id} />;
    case 'article':
      return <Article id={modalNav.screen.params.id} />;
    case 'medication':
      return <Medication id={modalNav.screen.params.id} />;
    case 'search':
      return <SearchResults />;
    default:
      return <Text>Unknown Page</Text>;
  }
};
